




















/* General */
import Vue from 'vue'

/* Helpers */
import TypeAssistant from '@/helpers/type-assistant'

/* Types */
import { SpamTypes } from '@/types'

export default Vue.extend({
  name: 'SpamHeader',

  props: {
    spamType: {
      type: Number,
      default: SpamTypes.NOT_SPAM,
    },
    isTogglingSpam: {
      type: Boolean,
      default: false,
    },
    allowToggle: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      SpamTypes,
    }
  },

  computed: {
    isSpam(): boolean {
      return TypeAssistant.isSpam(this.spamType)
    },
  },
})
